<script setup>
 import { defineProps, defineEmits, ref,computed } from 'vue'
 const props = defineProps({
   searchType: {
     type: Number,
     default: 0
   },
  
 })

 const searchTypeList=ref(
   [
       { label: '标题', value: 0 },
       { label: '全文', value: 1 },
   ]
 )
 const emit = defineEmits(['changeSearchType'])
const modelValue = computed({
  get: () => props.searchType,
  set: (val) => emit('changeSearchType', val)
})
</script>
<template>
 <a-select
      v-model:value="modelValue"
  
      :options="searchTypeList"

    ></a-select>
</template>